import React from 'react';
import _ from 'lodash';
import axios from 'axios';
import {Stack, Box, Skeleton} from '@mui/material';
import Carousel from 'react-multi-carousel';
import {PhotoProvider, PhotoView} from 'react-photo-view';
import {useQuery} from '@tanstack/react-query';
import CONFIG from '../config.js';
import 'react-multi-carousel/lib/styles.css';
import 'react-photo-view/dist/react-photo-view.css';

const responsive = {
    superLargeDesktop: {
        breakpoint: {max: 4000, min: 3000},
        items: 5,
    },
    desktop: {
        breakpoint: {max: 3000, min: 1024},
        items: 3,
    },
    tablet: {
        breakpoint: {max: 1024, min: 464},
        items: 2,
    },
    mobile: {
        breakpoint: {max: 464, min: 0},
        items: 1,
    },
};

const CarouselSkeleton = ()=>{
    return <Stack direction="row" gap={2}>
      <Skeleton width={350} height={400}/>
      <Skeleton width={350} height={400}/>
      <Skeleton width={350} height={400}/>
    </Stack>;
};

const FeedbackCarousel = props=>{
    let {tags} = props;
    let {data} = useQuery({
        queryKey: ['feedback_images', tags],
        queryFn: ()=>axios.get(CONFIG.API_BASE+'feedback_images', {params: {tags}}),
    });
    let urls = data?.data?.urls;
    if (!urls?.length)
        return <CarouselSkeleton/>;
    return <Box style={{
        width: '100%',
        height: '400px',
        overflow: 'hidden',
    }}>
      <PhotoProvider>
        <Carousel responsive={responsive}
          arrows
          infinite
          autoPlay
          autoPlaySpeed={10000}
          showDots
          draggable>
          {urls.map((url, i)=><Stack key={i} padding={2}>
            <PhotoView src={url}>
              <Box component="img" src={url} maxHeight="300px"
                sx={{objectFit: 'cover', objectPosition: 'top', cursor: 'pointer'}}/>
            </PhotoView>
          </Stack>)}
        </Carousel>
      </PhotoProvider>
    </Box>;
};

export default FeedbackCarousel;
